// ===== Content Calendar Workspace Data =====
export const contentGalleryImages = [
  'https://readdy.ai/api/search-image?query=modern%20minimal%20social%20media%20post%20background%20with%20abstract%20geometric%20shapes%20in%20soft%20coral%20and%20teal%20colors%2C%20clean%20professional%20aesthetic%20for%20content%20marketing%2C%20simple%20background&width=600&height=400&seq=301&orientation=landscape',
  'https://readdy.ai/api/search-image?query=professional%20LinkedIn%20article%20header%20image%20with%20business%20team%20collaboration%20scene%2C%20modern%20office%20environment%2C%20warm%20natural%20lighting%2C%20clean%20composition%2C%20simple%20background&width=600&height=400&seq=302&orientation=landscape',
  'https://readdy.ai/api/search-image?query=bright%20colorful%20Instagram%20carousel%20cover%20design%20with%20productivity%20icons%20and%20checkmark%20elements%20on%20warm%20gradient%20background%2C%20modern%20social%20media%20style%20with%20bold%20typography%2C%20simple%20background&width=600&height=400&seq=303&orientation=landscape',
  'https://readdy.ai/api/search-image?query=dark%20modern%20Twitter%20header%20image%20with%20code%20snippets%20and%20sprint%20board%20visual%20elements%2C%20developer%20aesthetic%20with%20monospace%20typography%20and%20terminal%20style%2C%20simple%20background&width=600&height=400&seq=304&orientation=landscape',
  'https://readdy.ai/api/search-image?query=eye-catching%20YouTube%20tutorial%20thumbnail%20with%20bold%20text%20overlay%2C%20split%20screen%20showing%20before%20and%20after%20workflow%20automation%2C%20warm%20orange%20and%20teal%20color%20scheme%2C%20modern%20tech%20aesthetic%2C%20simple%20background&width=600&height=400&seq=305&orientation=landscape',
  'https://readdy.ai/api/search-image?query=minimal%20product%20showcase%20social%20media%20graphic%20with%20clean%20layout%2C%20soft%20shadows%2C%20warm%20neutral%20tones%2C%20elegant%20typography%2C%20simple%20background&width=600&height=400&seq=306&orientation=landscape',
];

export const workspacePosts = [
  {
    id: 'post-1',
    date: '2026-05-01',
    dayName: 'Mon',
    platform: 'LinkedIn',
    platformIcon: 'ri-linkedin-box-line',
    themeType: 'Industry Trends',
    format: 'Article',
    formatIcon: 'ri-article-line',
    status: 'scheduled',
    caption: 'The biggest shift nobody is talking about in SaaS marketing this quarter.',
    creativeCopy: 'We analyzed 500+ projects this quarter and found one pattern that separated winners from everyone else. Read the full breakdown in our latest article.',
    script: 'Opening: Start with a surprising statistic. Hook: Ask the audience what they think is driving this shift. Body: Present the data-backed insight. CTA: Comment with your experience below.',
    hashtags: ['#SaaS', '#Marketing', '#IndustryTrends', '#Growth'],
    time: '10:00 AM',
    cta: 'Comment with your experience below.',
  },
  {
    id: 'post-2',
    date: '2026-05-02',
    dayName: 'Tue',
    platform: 'Instagram',
    platformIcon: 'ri-instagram-line',
    themeType: 'Product Tips',
    format: 'Carousel',
    formatIcon: 'ri-stack-line',
    status: 'draft',
    caption: '5 mistakes killing your productivity — and how to fix them today.',
    creativeCopy: 'Swipe to see the 5 workflow mistakes costing teams 10+ hours every week. Which one are you guilty of?',
    script: 'Slide 1: Bold title card. Slide 2-6: One mistake per slide with icon and stat. Slide 7: CTA to save this post.',
    hashtags: ['#Productivity', '#WorkLife', '#TeamTips', '#SaaS'],
    time: '11:30 AM',
    cta: 'Save this post for later and tag a teammate.',
  },
  {
    id: 'post-3',
    date: '2026-05-03',
    dayName: 'Wed',
    platform: 'Twitter',
    platformIcon: 'ri-twitter-x-line',
    themeType: 'Behind the Scenes',
    format: 'Thread',
    formatIcon: 'ri-chat-thread-line',
    status: 'approved',
    caption: 'How we shipped 3 features in 1 sprint — a thread.',
    creativeCopy: 'Thread: Here\'s the exact process we used to ship 3 major features in a single 2-week sprint. What would you add to this process?',
    script: 'Tweet 1: Hook with result. Tweet 2-7: Break down the process step-by-step. Tweet 8: Call for replies.',
    hashtags: ['#Startup', '#BuildInPublic', '#Product'],
    time: '9:00 AM',
    cta: 'What would you add? Reply and let me know.',
  },
  {
    id: 'post-4',
    date: '2026-05-05',
    dayName: 'Fri',
    platform: 'YouTube',
    platformIcon: 'ri-youtube-line',
    themeType: 'How-To Guide',
    format: 'Video',
    formatIcon: 'ri-video-line',
    status: 'draft',
    caption: 'Master this feature in 8 minutes — full tutorial.',
    creativeCopy: 'In this step-by-step tutorial, we walk through the advanced workflow automation feature that 90% of users overlook.',
    script: '0:00-0:30 Hook: Show the end result. 0:30-2:00 Setup walkthrough. 2:00-6:00 Deep dive with real examples. 6:00-8:00 Pro tips and CTA.',
    hashtags: ['#Tutorial', '#HowTo', '#Automation', '#Productivity'],
    time: '10:00 AM',
    cta: 'Subscribe for more tutorials every Saturday!',
  },
  {
    id: 'post-5',
    date: '2026-05-06',
    dayName: 'Sat',
    platform: 'Instagram',
    platformIcon: 'ri-instagram-line',
    themeType: 'Quick Tips',
    format: 'Reel',
    formatIcon: 'ri-film-line',
    status: 'scheduled',
    caption: 'This one trick changed everything for our team.',
    creativeCopy: 'POV: You discover the shortcut that saves 2 hours every single day. Tag someone who needs to see this!',
    script: '0-3s: Relatable pain point. 3-15s: Show the trick in action. 15-30s: Before/after comparison. 30-45s: CTA to share.',
    hashtags: ['#Reel', '#QuickTip', '#LifeHack', '#Workflow'],
    time: '2:00 PM',
    cta: 'Tag someone who needs to see this!',
  },
  {
    id: 'post-6',
    date: '2026-05-08',
    dayName: 'Mon',
    platform: 'LinkedIn',
    platformIcon: 'ri-linkedin-box-line',
    themeType: 'Community Engagement',
    format: 'Poll',
    formatIcon: 'ri-survey-line',
    status: 'approved',
    caption: 'We asked 1,000 professionals one question.',
    creativeCopy: 'Poll: What\'s the #1 thing holding your team back from peak productivity? Results and insights coming Monday. Vote now!',
    script: 'Single poll post with 4 options. Follow-up post with results the next week.',
    hashtags: ['#Poll', '#Community', '#ProfessionalGrowth'],
    time: '8:00 AM',
    cta: 'Vote now and share your reasoning below.',
  },
  {
    id: 'post-7',
    date: '2026-05-10',
    dayName: 'Wed',
    platform: 'Twitter',
    platformIcon: 'ri-twitter-x-line',
    themeType: 'Product Launch',
    format: 'Single Tweet',
    formatIcon: 'ri-twitter-x-line',
    status: 'draft',
    caption: 'It\'s finally here. Feature X is now live.',
    creativeCopy: 'After 6 months of development, Feature X is now live for all users. Here\'s what it does: [thread incoming]',
    script: 'Single tweet announcement. Thread follows with feature breakdown. Final tweet with free trial link.',
    hashtags: ['#ProductLaunch', '#NewFeature', '#SaaS'],
    time: '11:00 AM',
    cta: 'What would you add? Let us know in the comments.',
  },
  {
    id: 'post-8',
    date: '2026-05-12',
    dayName: 'Fri',
    platform: 'LinkedIn',
    platformIcon: 'ri-linkedin-box-line',
    themeType: 'Case Study',
    format: 'Article',
    formatIcon: 'ri-article-line',
    status: 'scheduled',
    caption: 'How Client Y increased output by 340%.',
    creativeCopy: 'This case study breaks down the exact strategy that helped a 12-person team 3x their output in 90 days.',
    script: 'Opening: The before state. Body: Step-by-step strategy breakdown. Results: Hard numbers. CTA: Comment which result surprised you.',
    hashtags: ['#CaseStudy', '#Results', '#BusinessGrowth'],
    time: '10:00 AM',
    cta: 'Comment which result surprised you most.',
  },
  {
    id: 'post-9',
    date: '2026-05-15',
    dayName: 'Mon',
    platform: 'Instagram',
    platformIcon: 'ri-instagram-line',
    themeType: 'FAQ',
    format: 'Story Series',
    formatIcon: 'ri-gallery-line',
    status: 'approved',
    caption: 'Your top 3 questions, answered in 60 seconds each.',
    creativeCopy: 'We collected the most asked questions this week and answered them all in 60 seconds each. Got more questions? Drop them below!',
    script: 'Story 1: Intro card. Story 2-4: One question per story with text overlay and quick answer. Story 5: CTA to ask more.',
    hashtags: ['#FAQ', '#QandA', '#InstagramStories'],
    time: '3:00 PM',
    cta: 'Got more questions? Drop them below!',
  },
  {
    id: 'post-10',
    date: '2026-05-17',
    dayName: 'Wed',
    platform: 'Facebook',
    platformIcon: 'ri-facebook-circle-line',
    themeType: 'Community Building',
    format: 'Event',
    formatIcon: 'ri-calendar-event-line',
    status: 'draft',
    caption: 'Join us live this Thursday — Q&A with our product team.',
    creativeCopy: 'We\'re hosting a live Q&A session with our product team. Bring your toughest questions. Set a reminder — link in comments.',
    script: 'Event announcement post. Live session script: 15 min intro, 30 min Q&A, 15 min wrap with next steps.',
    hashtags: ['#LiveQA', '#Community', '#ProductTeam'],
    time: '1:00 PM',
    cta: 'Set a reminder — link in comments.',
  },
  {
    id: 'post-11',
    date: '2026-05-19',
    dayName: 'Fri',
    platform: 'LinkedIn',
    platformIcon: 'ri-linkedin-box-line',
    themeType: 'Resource Download',
    format: 'Document',
    formatIcon: 'ri-file-list-line',
    status: 'scheduled',
    caption: 'Free template: The 2025 planning framework we actually use.',
    creativeCopy: 'We built the exact framework our team uses for quarterly planning. Grab it for free. Download link in first comment. No email required.',
    script: 'Short post with PDF preview image. Link to download in comments. Pin download comment.',
    hashtags: ['#FreeResource', '#Planning', '#Framework'],
    time: '9:00 AM',
    cta: 'Download link in first comment. No email required.',
  },
  {
    id: 'post-12',
    date: '2026-05-22',
    dayName: 'Mon',
    platform: 'YouTube',
    platformIcon: 'ri-youtube-line',
    themeType: 'Thought Leadership',
    format: 'Interview',
    formatIcon: 'ri-user-voice-line',
    status: 'draft',
    caption: 'We sat down with a $10M founder. Here\'s what they said.',
    creativeCopy: 'In this 20-minute interview, the founder of Startup Z reveals the one metric that matters more than revenue. Who should we interview next?',
    script: '0-2min: Intro and guest background. 2-15min: Deep dive on the one metric. 15-20min: Rapid-fire advice and closing.',
    hashtags: ['#Interview', '#FounderStory', '#Startup'],
    time: '10:00 AM',
    cta: 'Who should we interview next? Let us know below.',
  },
];

export const workspaceStats = {
  totalScheduled: 6,
  totalDraft: 4,
  totalApproved: 2,
  totalPublished: 28,
  thisMonthPosts: 12,
};

// ===== Content Editor Data =====
export const editablePosts = [
  {
    id: 'edit-1',
    title: 'LinkedIn — Industry Trends Article',
    platform: 'LinkedIn',
    platformIcon: 'ri-linkedin-box-line',
    currentCaption: 'The biggest shift nobody is talking about in SaaS marketing this quarter.',
    currentCreative: 'We analyzed 500+ projects this quarter and found one pattern that separated winners from everyone else.',
    currentScript: 'Opening: Start with a surprising statistic. Hook: Ask the audience what they think is driving this shift. Body: Present the data-backed insight. CTA: Comment with your experience below.',
    currentTheme: 'Educational',
    currentTone: 'Professional',
    currentCTA: 'Share your experience in the comments below.',
    currentHashtags: ['#SaaS', '#Marketing', '#IndustryTrends', '#Growth'],
    suggestedHashtags: ['#B2BMarketing', '#DigitalStrategy', '#SaaSGrowth', '#Leadership'],
    assets: [
      { id: 'asset-1', name: 'Hero Image', type: 'image', status: 'uploaded', url: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20business%20article%20hero%20image%20with%20abstract%20data%20visualization%20in%20blue%20and%20teal%20tones%20on%20clean%20white%20background%2C%20professional%20corporate%20style&width=600&height=340&seq=201&orientation=landscape' },
      { id: 'asset-2', name: 'Infographic Slide 1', type: 'infographic', status: 'draft', url: '' },
    ],
    aiSuggestions: [
      'Try a more provocative hook like "Your marketing strategy is already outdated."',
      'Add a customer quote in the middle for social proof.',
      'Shorten the CTA to one action — "Comment below" performs 18% better.',
    ],
  },
  {
    id: 'edit-2',
    title: 'Instagram — Product Tips Carousel',
    platform: 'Instagram',
    platformIcon: 'ri-instagram-line',
    currentCaption: '5 mistakes killing your productivity — and how to fix them today.',
    currentCreative: 'Swipe to see the 5 workflow mistakes costing teams 10+ hours every week. Which one are you guilty of?',
    currentScript: 'Slide 1: Bold title card. Slide 2-6: One mistake per slide with icon and stat. Slide 7: CTA to save this post.',
    currentTheme: 'Product',
    currentTone: 'Conversational',
    currentCTA: 'Save this post for later and tag a teammate.',
    currentHashtags: ['#Productivity', '#WorkLife', '#TeamTips', '#SaaS'],
    suggestedHashtags: ['#WorkFromHome', '#StartupLife', '#Efficiency', '#TimeManagement'],
    assets: [
      { id: 'asset-3', name: 'Carousel Cover', type: 'image', status: 'uploaded', url: 'https://readdy.ai/api/search-image?query=bright%20colorful%20Instagram%20carousel%20cover%20design%20with%20productivity%20icons%20and%20checkmark%20elements%20on%20gradient%20background%2C%20modern%20social%20media%20style%20with%20bold%20typography&width=600&height=600&seq=202&orientation=squarish' },
    ],
    aiSuggestions: [
      'Use a question in the first slide to boost swipe-through rate by 24%.',
      'Add emojis to each mistake card for visual consistency.',
      'Consider a "Before vs After" format for one of the slides.',
    ],
  },
  {
    id: 'edit-3',
    title: 'Twitter — Behind the Scenes Thread',
    platform: 'Twitter',
    platformIcon: 'ri-twitter-x-line',
    currentCaption: 'How we shipped 3 features in 1 sprint — a thread.',
    currentCreative: 'Thread: Here\'s the exact process we used to ship 3 major features in a single 2-week sprint. What would you add to this process?',
    currentScript: 'Tweet 1: Hook with result. Tweet 2-7: Break down the process step-by-step. Tweet 8: Call for replies.',
    currentTheme: 'Engagement',
    currentTone: 'Bold',
    currentCTA: 'What would you add? Reply and let me know.',
    currentHashtags: ['#Startup', '#BuildInPublic', '#Product'],
    suggestedHashtags: ['#IndieHackers', '#Developer', '#Agile', '#ShipFast'],
    assets: [
      { id: 'asset-4', name: 'Thread Header Image', type: 'image', status: 'uploaded', url: 'https://readdy.ai/api/search-image?query=dark%20modern%20Twitter%20header%20image%20with%20code%20snippets%20and%20sprint%20board%20visual%20elements%2C%20developer%20aesthetic%20with%20monospace%20typography%20and%20terminal%20style&width=600&height=300&seq=203&orientation=landscape' },
    ],
    aiSuggestions: [
      'Open with a number stat in the hook — "3 features. 2 weeks. Here\'s how."',
      'Add timestamps to make the thread feel more real and urgent.',
      'End with a controversial take to drive more replies.',
    ],
  },
  {
    id: 'edit-4',
    title: 'YouTube — How-To Guide Video',
    platform: 'YouTube',
    platformIcon: 'ri-youtube-line',
    currentCaption: 'Master this feature in 8 minutes — full tutorial.',
    currentCreative: 'In this step-by-step tutorial, we walk through the advanced workflow automation feature that 90% of users overlook.',
    currentScript: '0:00-0:30 Hook: Show the end result. 0:30-2:00 Setup walkthrough. 2:00-6:00 Deep dive with real examples. 6:00-8:00 Pro tips and CTA.',
    currentTheme: 'Educational',
    currentTone: 'Professional',
    currentCTA: 'Subscribe for more tutorials every Saturday!',
    currentHashtags: ['#Tutorial', '#HowTo', '#Automation', '#Productivity'],
    suggestedHashtags: ['#YouTubeTutorial', '#TechTips', '#Software', '#Workflow'],
    assets: [
      { id: 'asset-5', name: 'Video Thumbnail', type: 'image', status: 'uploaded', url: 'https://readdy.ai/api/search-image?query=eye-catching%20YouTube%20tutorial%20thumbnail%20with%20bold%20text%20overlay%2C%20split%20screen%20showing%20before%20and%20after%20workflow%20automation%2C%20bright%20orange%20and%20blue%20color%20scheme%2C%20modern%20tech%20aesthetic&width=640&height=360&seq=204&orientation=landscape' },
      { id: 'asset-6', name: 'Tutorial Video', type: 'video', status: 'uploaded', url: '' },
    ],
    aiSuggestions: [
      'Add a "mistake" moment at 3:00 to increase retention.',
      'Use on-screen text for key takeaways — viewers retain 60% more.',
      'Ask a poll in the comments for the next tutorial topic.',
    ],
  },
];

export const toneOptions = ['Professional', 'Conversational', 'Bold', 'Playful', 'Empathetic', 'Authoritative'];
export const themeOptions = ['Product', 'Educational', 'Engagement', 'Awareness', 'Campaign', 'Promotional'];
export const ctaPresets = [
  'Share your experience in the comments below.',
  'Save this post for later and tag a teammate.',
  'Reply with your thoughts — we read every comment.',
  'What would you add? Let us know below.',
  'Drop a if you agree.',
  'Link in bio for the full resource.',
];

// ===== Export & Download Center Data =====
export const exportPackages = [
  {
    id: 'pkg-1',
    name: 'May Content Bundle',
    type: 'Monthly Calendar',
    posts: 12,
    platforms: ['LinkedIn', 'Instagram', 'Twitter', 'YouTube', 'Facebook'],
    formats: ['Article', 'Carousel', 'Thread', 'Video', 'Reel', 'Poll'],
    size: '24.5 MB',
    lastUpdated: '2026-05-19',
  },
  {
    id: 'pkg-2',
    name: 'Week 1 Content Pack',
    type: 'Campaign Bundle',
    posts: 3,
    platforms: ['LinkedIn', 'Instagram', 'Twitter'],
    formats: ['Article', 'Carousel', 'Thread'],
    size: '8.2 MB',
    lastUpdated: '2026-05-01',
  },
  {
    id: 'pkg-3',
    name: 'Product Launch Series',
    type: 'Campaign Bundle',
    posts: 5,
    platforms: ['LinkedIn', 'Twitter', 'Instagram', 'YouTube'],
    formats: ['Single Tweet', 'Article', 'Reel', 'Video', 'Story'],
    size: '15.8 MB',
    lastUpdated: '2026-05-10',
  },
  {
    id: 'pkg-4',
    name: 'Educational Content Pack',
    type: 'Campaign Bundle',
    posts: 4,
    platforms: ['YouTube', 'LinkedIn'],
    formats: ['Video', 'Article'],
    size: '42.1 MB',
    lastUpdated: '2026-05-15',
  },
];

export const exportFormats = [
  { id: 'single-post', name: 'Single Post Package', description: 'Download one post with all assets', icon: 'ri-file-text-line' },
  { id: 'campaign-bundle', name: 'Campaign Bundle', description: 'All posts from a selected campaign', icon: 'ri-folder-zip-line' },
  { id: 'monthly-calendar', name: 'Full Monthly Calendar', description: 'Complete month with all posts and assets', icon: 'ri-calendar-2-line' },
  { id: 'csv-export', name: 'CSV Export', description: 'Structured data for tracking systems', icon: 'ri-file-list-3-line' },
];

export const postPreviewItems = [
  { field: 'Caption', value: 'The biggest shift nobody is talking about in SaaS marketing this quarter.' },
  { field: 'Hashtags', value: '#SaaS #Marketing #IndustryTrends #Growth' },
  { field: 'Platform', value: 'LinkedIn' },
  { field: 'Format', value: 'Article' },
  { field: 'Theme', value: 'Industry Trends' },
  { field: 'Creative Copy', value: 'We analyzed 500+ projects this quarter and found one pattern that separated winners from everyone else.' },
  { field: 'Media', value: 'Hero Image (600x340px), Infographic Slide 1' },
];